import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/* ── tiny helper to Title-Case words ─────────────────────────── */
const toTitle = (str = '') =>
  str
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

export default function SearchBar() {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  /* ── fetch autocomplete (debounced 300 ms) ─────────────────── */
  useEffect(() => {
    if (!query.trim()) {
      setSuggestions([]);
      return;
    }

    const id = setTimeout(async () => {
      try {
        const res = await fetch(
          `https://93498017-namedbygod-autocomplete-worker.d-3bd.workers.dev/?q=${encodeURIComponent(
            query
          )}`
        );
        const raw = await res.json();

        // de-duplicate by name_en
        const seen = new Set();
        const unique = raw.filter((item) => {
          if (seen.has(item.name_en)) return false;
          seen.add(item.name_en);
          return true;
        });

        setSuggestions(unique);
      } catch {
        setSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(id);
  }, [query]);

  /* ── click handler ─────────────────────────────────────────── */
  const choose = (name) => {
    setQuery('');
    setSuggestions([]);
    navigate(`/name/${name}`);
  };

  /* ── render ───────────────────────────────────────────────── */
  return (
    <div className="relative w-full max-w-xl mx-auto">
      <input
        className="w-full bg-white text-gray-900 placeholder-gray-500
                   border border-gray-300 rounded-lg px-4 py-3 text-lg
                   focus:outline-none focus:ring-2 focus:ring-blue-400"
        placeholder="Search biblical names …"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {suggestions.length > 0 && (
        <ul
          className="absolute z-20 mt-2 w-full bg-white border border-gray-200
                     rounded-lg shadow-lg max-h-72 overflow-y-auto"
        >
          {suggestions.map((s, idx) => (
            <li
              key={`${s.name_en}-${idx}`}
              onClick={() => choose(s.name_en)}
              className="cursor-pointer hover:bg-blue-50 transition px-4 py-2"
            >
              <div className="flex justify-between">
                <span className="font-medium text-gray-800">
                  {toTitle(s.term)}
                </span>
                <span className="text-sm text-gray-500">
                  {toTitle(s.name_en)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
